import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  // Initial time: 00:54:21
  const [timeLeft, setTimeLeft] = useState(54 * 60 + 21);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-amber-600 text-white px-4 py-3 shadow-lg flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-sm md:text-base font-medium" data-id="element-1">
      <div className="flex items-center gap-2 text-center" data-id="element-2">
        <span className="animate-pulse text-red-900" data-id="element-3">🔴</span>
        <span data-id="element-4">
          ATENCIÓN: La oferta de lanzamiento de MinHealthGroup con el 90% de
          descuento finaliza hoy a la medianoche.
        </span>
      </div>
      <div className="flex items-center gap-2 bg-black/20 px-3 py-1 rounded-md font-mono font-bold tracking-wider shrink-0" data-id="element-5">
        <Clock className="w-4 h-4" data-id="element-6" />
        {formatTime(timeLeft)}
      </div>
    </div>;
}